/**
 * Centralized username validation and normalization utilities
 * Keeps consistency with backend rules and prevents duplication
 */

const USERNAME_REGEX = /^(?=.{3,30}$)[a-z0-9](?:[a-z0-9._-]*[a-z0-9])?$/;
const USERNAME_VALIDATION_MESSAGE = "Usuario inválido. Usa 3-30 caracteres en minúsculas (letras, números, ., _, -).";

const usernameUtils = {
  regex: USERNAME_REGEX,
  validationMessage: USERNAME_VALIDATION_MESSAGE,
  
  normalize(value) {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
  },
  
  isValid(value) {
    return USERNAME_REGEX.test(value);
  },
  
  sanitizeInput(value) {
    // For real-time input: lowercase + remove spaces
    return typeof value === "string" ? value.toLowerCase().replace(/\s+/g, "") : "";
  },
};

export default usernameUtils;
